import FormWrapper from './FormWrapper';

export const Form = FormWrapper;